
import { Component, Prop, Vue } from "vue-property-decorator";
import { Category } from "@/types/woothee_category";

@Component({})
export default class extends Vue {
  @Prop()
  pc!: string;

  @Prop()
  sp!: string;

  getSrc(): string {
    if ((this as any).$ua.category === Category.Smartphone) {
      if (this.sp && this.sp.length > 0) {
        return this.sp;
      }
    }

    return this.pc;
  }
}
